import { useContext } from 'react'
import { WellnessTileNavigationContext } from './wellnessTileNavigationContextValue'

export function useWellnessTileNavigation() {
  return useContext(WellnessTileNavigationContext)
}
